import { Userpilot } from 'userpilot'

import AppConfig from '../AppConfig'

import { Service } from './index'

type UserPilot = typeof Userpilot

declare global {
  interface Window {
    userpilot?: UserPilot
  }
}

const userpilot: Service<UserPilot> = {
  async init() {
    if (AppConfig.USER_PILOT_TOKEN) {
      Userpilot.initialize(AppConfig.USER_PILOT_TOKEN)
    }
  },

  loaded() {
    return window.userpilot !== undefined
  },
  instance() {
    return window.userpilot
  },
  identify(user) {
    if (AppConfig.USER_PILOT_TOKEN) {
      Userpilot.identify(user?.id, {
        id: user?.id,
        email: user?.email,
        name: user?.name,

        retailerContentDiscovery: user?.retailerContentDiscovery,
        enableBrandRequests: user?.enableBrandRequests,
        enablePicInDiscoverBrands: user?.enablePicInDiscoverBrands,
        enableIndustrySuggestions: user?.enableIndustrySuggestions,
        brandIds: user?.brandIds,
        isFacebookAuthenticated: user?.isFacebookAuthenticated,
      })
    }
  },
  track(details) {
    // user pilot accepts meta data but it doesn't appear to be very useful in distinguishing events
    const { type, data } = details
    const eventName = [type]
    if (data?.name) {
      eventName.push(String(data.name))
    }
    if (AppConfig.USER_PILOT_TOKEN) {
      Userpilot.track(eventName.join(':'))
    }
  },
  page() {
    // user pilot docs specify we need to reload on page change, disabled due to event tracking inconsistencies
    // https://docs.userpilot.com/article/21-install-userpilot-on-your-web-app
    // if (AppConfig.USER_PILOT_TOKEN) {
    //   Userpilot.reload()
    // }
  },
}

export default userpilot
